/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class ActionRequestProgMes {
    constructor(data) {
        if (data) {
            Object.assign(this, data);

            if (this.resolutionDate) {
                this.resolutionDate = this.getDateWithoutSecond(this.resolutionDate);
            } else {
                let date = new Date(Date.now());
                this.resolutionDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
            }
        } else {
            this.actions = [];
            let date = new Date(Date.now());
            this.resolutionDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
        }
    }

    /**
     * Convert a string date to a Date format YYYY-mm-dd hh:mm
     *
     * @param {String} the string date
     */
    getDateWithoutSecond(stringDate) {
        let date = new Date(stringDate);
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
    }
}

export { ActionRequestProgMes };



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/ActionRequestProgMes.js